import { MappedPassengerType } from '../../types';
import { Container } from './styles';

interface ListHeaderInterface {
  apiFetched: boolean;
  filteredEntity: MappedPassengerType[];
  entityString: { singular: string, plural: string };
  doesListExists: boolean;
}

export default function ListHeader({
  apiFetched,
  filteredEntity,
  entityString,
  doesListExists,
}: ListHeaderInterface) {
  return (
    <Container doesListExists={doesListExists} apiFetched={apiFetched}>
      <strong>
        {filteredEntity?.length}
        {' '}
        {filteredEntity?.length === 1 ? entityString.singular : entityString.plural}
      </strong>
    </Container>
  );
}
